module.exports = __webpack_public_path__ + "img/office-badge.9d584bdd.jpg";